module.exports = __webpack_public_path__ + "img/carousel_1.8112e889.png";